import React, { useMemo } from "react";
import { useAppConfig } from "../../../AppConfigProvider";
import { useAuth } from "../../../hooks/useAuth";
import { useProgressStats } from "../../../hooks/useProgressStats";
import { useVisitSession } from "../../../contexts/VisitSessionContext";
import { useGetEnrolledCoursesForStudentQuery, useMeQuery } from "../../../graphql/generated/graphql";
import SlideInMenu from "../../../components/navigation/SlideInMenu/SlideInMenu";

function SlideInMenuContainer({ courses, visible, slideAnim, onClose, onSettingsPress }) {
  const { logout } = useAuth();
  const { endSession } = useVisitSession();

  const appConfig = useAppConfig();
  const hasDegrees = appConfig.hasDegrees;

  const courseIds = courses.map((course) => course.id);
  const { progressStats, degree } = useProgressStats(courses, courseIds);

  const integrationId = appConfig.axioSchools[0];
  const { data } = useGetEnrolledCoursesForStudentQuery({
    variables: {
      schoolId: integrationId,
      page: 1,
      pageSize: 10,
    },
    skip: !integrationId,
  });
  const courseList = data?.getEnrolledCoursesForStudent?.data?.courses || [];
  const coursesData = useMemo(() => {
    const list = [...courseList];
    list.sort((a, b) => b.progress - a.progress);
    return list;
  }, [courseList]);

  const { data: meData } = useMeQuery();

  const resourcesData = useMemo(() => {
    return {
      isShow:
        appConfig.officialTranscriptsUrl ||
        appConfig.financialInformationUrl ||
        appConfig.helpCenterUrl ||
        appConfig.schoolResourcesUrl,
      officialTranscriptsUrl: appConfig.officialTranscriptsUrl,
      financialInformationUrl: appConfig.financialInformationUrl,
      helpCenterUrl: appConfig.helpCenterUrl,
      schoolResourcesUrl: appConfig.schoolResourcesUrl,
    };
  }, [appConfig]);

  const supportData = useMemo(() => {
    return {
      isShow: appConfig.reportProblemUrl || appConfig.scheduleAdvisorCallUrl,
      reportProblemUrl: appConfig.reportProblemUrl,
      scheduleAdvisorCallUrl: appConfig.scheduleAdvisorCallUrl,
    };
  }, [appConfig]);

  const handleLogout = async () => {
    await endSession();
    logout();
  };

  return (
    <SlideInMenu
      visible={visible}
      slideAnim={slideAnim}
      meData={meData}
      hasDegrees={hasDegrees}
      onSettingsPress={onSettingsPress}
      progressStats={progressStats}
      degreeName={degree?.name}
      coursesData={coursesData}
      resourcesData={resourcesData}
      supportData={supportData}
      onLogout={handleLogout}
      onClose={onClose}
    />
  );
}

export default SlideInMenuContainer;
